<div class="address-list">
  <div class="address-card-add" (click)="onAddAddress()">
    <mat-icon>add</mat-icon>
    <div style="font-size: 24px;">Adicionar endereço</div>
  </div>

  <div *ngFor="let address of addresses" class="address-card">
    <div class="address-details">
      <div>{{ address.street }}{{ address.number ? ', ' + address.number : '' }}{{ address.complement ? ', ' +
        address.complement : '' }}<br />
        {{ address.district }}<br />{{ address.city }}<br />{{ address.state! | stateFormat }}<br /> {{ address.zipCode
        }}
      </div>
      <br />
      <div><i>{{ address.commercial ? 'Endereço Comercial' : 'Endereço de atendimento' }}</i></div>
    </div>
    <div class="address-actions">
      <button mat-button (click)="editAddress.emit(address.id)">Editar</button>
    <button mat-button color="warn" (click)="deleteAddress.emit(address.id)">Remover</button>
    </div>
  </div>
</div>